export default __webpack_public_path__ + "static/media/euler-club-bg.718dc004.png";